import React from "react";
import { Icon } from "../../_foundation/_buttons";
import PageViewHelper from "../PageViewHelper";
import Audio from "../../modules/courses/parts/Audio";
import ApiHelper from "../../../helpers/ApiHelper";
import UrlHelper from "../../../helpers/UrlHelper";
import { cloneDeep } from "lodash";
import { Cell, Grid, Row } from "../../_foundation/_grid";

function ElementLessonGrid({ element }) {
  if (!element.options.view) element.options.view = "embed";
  if (!element.options.perrow_md) element.options.perrow_md = 8;

  return (
    <>
      <div style={PageViewHelper.applyOptions(element)}>
        <Grid>
          <Row margin="xy">
            {element.extra.category &&
              element.extra.category.lessons &&
              element.extra.category.lessons.map((lesson) => {
                const pseudoElement = cloneDeep(element);
                element.extra.lesson = lesson;
                return (
                  <Cell sm={24} md={element.options.perrow_md} key={lesson.id}>
                    {element.options.view === "embed" && <ViewEmbed element={pseudoElement} />}
                    {element.options.view === "link" && <ViewLink element={pseudoElement} />}
                  </Cell>
                );
              })}
          </Row>
        </Grid>
      </div>
    </>
  );
}

const ViewLink = ({ element }) => {
  if (!element.extra || !element.extra.lesson)
    return <div className="text-center">Lektion nicht gefunden.</div>;

  const { course, lesson } = element.extra;

  let url = UrlHelper.url("courseLesson")
    .replace(":courseSlug", course.slug)
    .replace(":lessonSlug", lesson.slug);

  if (lesson.access && lesson.access.hasAccess === false && lesson.access.showBefore === true) {
    return (
      <div className="lessongrid-item">
        <div>
          <img src={lesson.image} alt="" />
        </div>
        <div className="grid-thumbnail-text">
          <h3>
            <Icon icon="lock" /> {lesson.name}
          </h3>
          {/*<div
            dangerouslySetInnerHTML={{
              __html: lesson.description_html,
            }}
          />*/}
        </div>
      </div>
    );
  } else {
    return (
      <a href={url} className="lessongrid-item">
        <div>
          <img src={lesson.image} alt="" />
        </div>
        <div className="grid-thumbnail-text">
          <h3>{lesson.name}</h3>
          {/*<div
            dangerouslySetInnerHTML={{
              __html: lesson.description_html,
            }}
          />*/}
        </div>
      </a>
    );
  }
};

const ViewEmbed = ({ element }) => {
  if (!element.extra || !element.extra.lesson)
    return <div className="text-center">Lektion nicht gefunden.</div>;

  const { lesson } = element.extra;

  if (lesson.type === "audio") {
    return (
      <div>
        <div className="course-lesson-audio">
          <Audio lesson={lesson} onListen={(currentTime) => {}} />
        </div>
        <div className="text-right">
          <a
            href={ApiHelper.url("downloads.audio", { id: lesson.id })}
            className="small primary hollow button"
          >
            <Icon icon="download" left /> DOWNLOAD
          </a>
        </div>
      </div>
    );
  } else if (lesson.type === "vimeo") {
    let embedUrl = `https://player.vimeo.com/video/${lesson.content}`;
    return (
      <div className="responsive-embed widescreen">
        <iframe
          src={embedUrl}
          frameBorder="0"
          allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          title="vimeoPlayer"
        ></iframe>
      </div>
    );
  } else if (lesson.type === "youtube") {
    let embedUrl = `https://www.youtube.com/embed/${lesson.content}`;
    return (
      <div className="responsive-embed widescreen">
        <div id="youtubePlayer">
          <iframe
            src={embedUrl}
            frameBorder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            title="YoutubePlayer"
          ></iframe>
        </div>
      </div>
    );
  } else if (lesson.type === "embed") {
    return (
      <div className="responsive-embed widescreen">
        <div dangerouslySetInnerHTML={{ __html: lesson.content }} />
      </div>
    );
  }

  return null;
};

export default ElementLessonGrid;
